module.exports = __webpack_public_path__ + "static/media/14_tn.2d19d094.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/14_tn.jpg
// module id = 228
// module chunks = 0